unable to read source [project]/node_modules/@grpc/proto-loader/src/index.ts